<template>
    <!-- 导航 -->
<div class="iconNavClass" v-show="iconNavHeader.length">
    <div style="display:flex;margin-left:100px;margin-top: 17px;">
        <span v-for="(o, index) in iconNavHeader" :key="index" @click="headerNavMainFunc(o)"
         :class="typeof o === 'object' ? isFlagLiClass === o.path ? filterFn(o.path, true) : filterFn(o.path) : 'icon_nav_line'">
            {{ typeof o === 'object' ? $t(`${o.msg}`) : '|' }}
        </span>
    </div>
</div>
</template>
<script>
export default {
    // props: ["elementItem", "iconNavTitle"],
    data () {
        return {
            dataElemets: [],
            routes: [],
            filterArr: ['financial', 'planUpgrade', 'notificationSet'],
            isFilterFlag: false
        }
    },
    methods: {
        headerNavMainFunc (item) {
            this.routes.forEach(element => {
                if (item.path === element.path) {
                    this.navRouterState(element)
                }
            })
        },
        filterFn (data, fg) {
            let ok = this.filterArr.filter(fl => fl === data)[0]
            let res = ''
            if (!ok) {
                fg ? res += 'navLiClass icon_nav_span' : res += 'icon_nav_span'
                return res
            } else {
                res += 'isIcon_nav_span'
                return res
            }
        }
    },
    mounted () {
        let routes = this.$router.options.routes
        this.routes = routes
            .filter(
                item =>
                    item.hasOwnProperty('meta') && item.meta.hasOwnProperty('navObj')
            )
            .map(item => item.meta.navObj)
    },
    computed: {
        isFlagLiClass () {
            return this.$store.state.isFlagLiClass
        },
        iconNavHeader () {
            return this.$store.state.iconNavHeader
        }
    }
}
</script>
<style scoped>
.isIcon_nav_span{
  width: 145px;
  cursor: pointer;
  height: 24px;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  text-align: center;
  color: rgba(51, 51, 51, 0.5);
  cursor: not-allowed;
}
.iconNavClass {
  display: flex;
  width: 1280px;
  height:60px;
  position: fixed;
  top: 60px;
  /* background-color: rgba(0, 181, 226, 0.1); */
  background-color: #E5F7FC;
  -webkit-box-shadow: 0 1px 0 0 rgba(0, 181, 226, 0.3);
  box-shadow: 0 1px 0 0 rgba(0, 181, 226, 0.3);
  z-index: 2;
}
.navLiClass {
  color: var(--black) !important;
  font-weight: 500 !important;
  box-sizing: border-box;
  cursor: pointer;
}
.icon_nav_line {
  width: 5px;
  height: 24px;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  color: var(--black);
}
.icon_header_title {
  height: 56px;
  font-family: sans-serif;
  font-size: 38px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.1px;
  color: var(--black);
  margin: 0px;
}
.icon_nav_span {
  width: 145px;
  cursor: pointer;
  height: 24px;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  text-align: center;
  color: rgba(51, 51, 51, 0.5);
}
.icon_nav_span:hover{
  margin-top: -2px;
}
</style>
